'use client';

import React from 'react';
import ArrowDown from 'public/arrow-down.svg';
import { useRouter } from 'next/navigation';

export default function SupportHeader() {
  const router = useRouter();

  const goBack = () => {
    router.back();
  };

  return (
    <div className="flex items-center gap-2 px-2 py-8" onClick={goBack}>
      <ArrowDown className="text-2xl text-white rotate-90" />
      <p className="text-base font-semibold leading-none text-white">Support</p>
    </div>
  );
}
